import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37ea3f37"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Схемы погрузки", -1))
const _hoisted_4 = ["id"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "schemeInfoBlock" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "schemeInfoBlock" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Заказы:", -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode()
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { class: "schemeInfoBlock" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode()
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Объем пиломатериалов (м")
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_25 = { class: "schemeInfoBlock" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Смещение ЦТ:", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-12" }
const _hoisted_30 = ["src"]
const _hoisted_31 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlanContainerResultLoadingSchemeJournal = _resolveComponent("PlanContainerResultLoadingSchemeJournal")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_PlanContainerResultLoadingSchemeJournal, {
        onContentReady: _ctx.onContentReady,
        onSelectionChanged: _ctx.onSelectionChanged,
        parentModel: _ctx.parentModel,
        parentEditingConfig: _ctx.parentEditingConfig
      }, null, 8, ["onContentReady", "onSelectionChanged", "parentModel", "parentEditingConfig"])
    ]),
    _createVNode(_component_DxLoadPanel, {
      position: _ctx.loadingPanelPosition,
      visible: _ctx.loading,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loading) = $event)),
      "show-indicator": true,
      "show-pane": true,
      shading: false,
      "close-on-outside-click": false
    }, null, 8, ["position", "visible"]),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: _ctx.loadingSchemeDomId,
          class: "col-10",
          style: {"background":"white"}
        }, [
          (_ctx.model.scheme)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h5", null, " Схема погрузки №" + _toDisplayString(_ctx.model.scheme.number) + " в ТС \"" + _toDisplayString(_ctx.model.container.code) + "\" ", 1),
                      _createElementVNode("p", _hoisted_8, [
                        _createElementVNode("strong", null, "Количество контейнеров: " + _toDisplayString(_ctx.model.scheme.containerCount), 1),
                        _hoisted_9,
                        _createElementVNode("span", null, "Грузоподъемность(кг): " + _toDisplayString(Intl.NumberFormat("ru-RU").format(
                      _ctx.model.container.loadCapacity
                    )), 1)
                      ]),
                      _createElementVNode("p", _hoisted_10, [
                        _hoisted_11,
                        _hoisted_12,
                        _hoisted_13,
                        _createElementVNode("span", {
                          style: {"word-wrap":"normal"},
                          innerHTML: _ctx.orders
                        }, null, 8, _hoisted_14),
                        _hoisted_15
                      ]),
                      _createElementVNode("p", _hoisted_16, [
                        _createElementVNode("strong", null, "Продукция (" + _toDisplayString(_ctx.model.packagesSum) + " шт):", 1),
                        _hoisted_17,
                        _hoisted_18,
                        _createElementVNode("span", {
                          style: {"word-wrap":"normal"},
                          class: "packages",
                          innerHTML: _ctx.packages
                        }, null, 8, _hoisted_19),
                        _hoisted_20,
                        _createElementVNode("span", null, " Вес пиломатериалов нетто (кг): " + _toDisplayString(Intl.NumberFormat("ru-RU").format(
                      _ctx.model.scheme.packagesWeight
                    )) + " (" + _toDisplayString(_ctx.model.containerLoadCapacityPercent) + "%) ", 1),
                        _hoisted_21,
                        _createElementVNode("span", null, " Вес пиломатериалов брутто (кг): " + _toDisplayString(Intl.NumberFormat("ru-RU").format(
                      _ctx.model.packagesBruttoWeight
                    )) + " (" + _toDisplayString(_ctx.model.containerLoadCapacityBruttoPercent) + "%) ", 1),
                        _hoisted_22,
                        _createElementVNode("span", null, [
                          _hoisted_23,
                          _hoisted_24,
                          _createTextVNode("): " + _toDisplayString(Intl.NumberFormat("ru-RU").format(
                      _ctx.model.scheme.packagesVolume
                    )) + " (" + _toDisplayString(_ctx.model.containerLoadVolumePercent) + "%) ", 1)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_25, [
                        _hoisted_26,
                        _hoisted_27,
                        _createElementVNode("span", null, "Продольное " + _toDisplayString(Intl.NumberFormat("ru-RU").format(
                      _ctx.model.scheme.massCenterLongitudinalDisplacement
                    )) + " мм " + _toDisplayString(_ctx.model.scheme.massCenterLongitudinalDisplacementDirection) + " (допустимое " + _toDisplayString(Intl.NumberFormat("ru-RU").format(
                      _ctx.model.scheme.permissibleLongitudinalDisplacement
                    )) + " мм). Поперечное " + _toDisplayString(Intl.NumberFormat("ru-RU").format(
                      _ctx.model.scheme.massCenterTransverseDisplacement
                    )) + " мм " + _toDisplayString(_ctx.model.scheme.massCenterTransverseDisplacementDirection) + " (допустимое " + _toDisplayString(Intl.NumberFormat("ru-RU").format(
                      _ctx.model.scheme.permissibleTransverseDisplacement
                    )) + " мм)", 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.topViewSchemes, (topViewScheme, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("strong", null, "Вид сверху. Ярус № " + _toDisplayString(index + 1), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("img", {
                            style: {"max-height":"100%","max-width":"100%"},
                            src: `data:image/png;base64, ${topViewScheme}`
                          }, null, 8, _hoisted_30)
                        ])
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.verticalCutSchemes, (verticalCutScheme, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("strong", null, "Вид сбоку. Разрез № " + _toDisplayString(index + 1) + "-" + _toDisplayString(index + 1), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("img", {
                            style: {"max-height":"100%","max-width":"100%"},
                            src: `data:image/png;base64, ${verticalCutScheme}`
                          }, null, 8, _hoisted_31)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 8, _hoisted_4))
      : _createCommentVNode("", true)
  ]))
}